import cookies from 'js-cookie';

export const onelink = 'https://go.onelink.me/iGO2/5bbbb3b4';
// 裂变一期
export const fissionOnelink = 'https://go.onelink.me/iGO2/referral';
// 分享吊起控制面板 通用params
export const shareParams = {
    type: 'type',
    caption: '',
    desc: '',
    siteName: '',
    imgUrl: '//cdn-static.kwai.net/kos/s101/nlav11312/kwai-share/kos/nlav10586/encourage/invite-share-1200_600.afe757d0c9e2b1fa.png',
    siteUrl: '',
    platform: [
        'whatsapp',
        'facebook_kwai',
        'messenger',
        'messenger_lite',
        'twitter',
        'twitter_lite',
        'telegram',
        'pinterest',
        'line',
        'sms',
        'telegram',
        'share_copylink',
        'copy',
        'more',
    ],
    shareSource: 'shareSource',
    activity_name: '',
    activity_id: '',
};

// export const mProKwaiOrigin = process.env.HOST || window.location.origin;

export const mProKwaiOrigin = process.env.HOST;

export const userId = cookies.get('userId') || cookies.get('ud') || '';

// 国家列表
export enum COUNTRY_LIST {
    // PRO
    BRA = 'br', // 巴西
    COL = 'col', // 哥伦比亚
    MEX = 'mex', // 墨西哥
    ARG = 'arg', // 阿根廷
    PER = 'per', // 秘鲁
    CHL = 'chl', // 智利
    ECU = 'ecu', // 厄瓜多尔
    DOM = 'dom', // 多米尼加
    // SV
    IDN = 'idn', // 印尼
    PAK = 'pak', // 巴基斯坦
    // ME
    TUR = 'tur', // 土耳其
    EGY = 'egy', // 埃及
    IRQ = 'irq', // 伊拉克
    DZA = 'dza', // 阿尔及利亚
    SAU = 'sau', // 沙特阿拉伯王国
}

// 当前国家
export const webCountry = cookies.get('web_country') as COUNTRY_LIST || '';

// 支持的桶列表
export enum BUCKET_LIST {
    BR = 'br',
    SPA = 'spa',
}

// 当前桶
export const webBucket = cookies.get('bucket') as BUCKET_LIST || cookies.get('web_bucket') as BUCKET_LIST;

// 各个国家时间展示格式列表
const timeFormatTypeMap: Partial<Record<COUNTRY_LIST, string>> = {
    [COUNTRY_LIST.BRA]: 'YYYY-MM-DD HH:mm',
    [COUNTRY_LIST.COL]: 'DD-MM-YYYY HH:mm',
    [COUNTRY_LIST.MEX]: 'DD-MM-YYYY HH:mm',
};

// 时间展示格式
export const timeFormatType = timeFormatTypeMap[webCountry];

// 各个国家时区列表
const timezoneMap: Partial<Record<COUNTRY_LIST, number>> = {
    [COUNTRY_LIST.BRA]: 3,
    [COUNTRY_LIST.COL]: 5,
    [COUNTRY_LIST.MEX]: 6,
};

// 时区
export const timezone = timezoneMap[webCountry];

// 货币格式化列表
const currencyFormatTypeMap: Partial<Record<COUNTRY_LIST, string>> = {
    [COUNTRY_LIST.BRA]: 'pt-br',
    [COUNTRY_LIST.COL]: 'es-co',
    [COUNTRY_LIST.MEX]: 'es-mx',
};

export const currencyFormatType = currencyFormatTypeMap[webCountry];

export const country = cookies.get('web_country') || '';

const countryUnitMap:Record<string, string> = {
    col: 'COP',
    mex: 'MXN',
};

export const countryUnit = countryUnitMap[country];

const areaCodeMap: Record<string, string> = {
    br: '+55',
    col: '+57',
    mex: '+52',
};

export const areaCode = areaCodeMap[country];

const accountKeyMap: Record<string, string> = {
    br: 'KWAI_CASH',
    col: 'KWAI_PRO_CASH_COL',
    mex: 'KWAI_PRO_CASH_MEX',
};

export const countryAccountKey = accountKeyMap[country];

const giftCardKeyMap: Record<string, string> = {
    br: 'KWAI_PRO_DTONE_KEY',
    col: 'KWAI_PRO_DTONE_KEY_COL',
    mex: 'KWAI_PRO_DTONE_KEY_MEX',
};

export const giftCardKey = giftCardKeyMap[country];

export const defaultOneLink = 'https://go.onelink.me/iGO2';

// 国家代码和缩写映射关系
export const COUNTRY_CODE_MAP = {
    br: 'BRA',  // 巴西
    id: 'IDN',  // 印尼
    eg: 'EGY',  // 埃及
    egy: 'EGY',
    co: 'COL',  // 哥伦比亚
    col: 'COL',
    mx: 'MEX',  // 墨西哥
    mex: 'MEX',
    ar: 'ARG',  // 阿根廷
    arg: 'ARG',
    pe: 'PER',  // 秘鲁
    per: 'PER',
    cl: 'CHL',  // 智利
    ci: 'CHL',
    chl: 'CHL',
    ec: 'ECU',  // 厄瓜多尔
    ecu: 'ECU',
    dr: 'DOM',  // 多米尼加
    do: 'DOM',
    dom: 'DOM',
    pk: 'PAK',  // 巴基斯坦
    pak: 'PAK',
    tu: 'TUR',  // 土耳其
    tr: 'TUR',
    tur: 'TUR',
    iz: 'IRQ',  // 伊拉克
    iq: 'IRQ',
    irq: 'IRQ',
    ag: 'DZA',  // 阿尔及利亚
    dz: 'DZA',
    dza: 'DZA',
};

// 各个国家对应的货币单位
const countryCurrencyUnit: Record<COUNTRY_LIST, string> = {
    [COUNTRY_LIST.BRA]: 'R$',
    [COUNTRY_LIST.COL]: '$',
    [COUNTRY_LIST.MEX]: '$',
    [COUNTRY_LIST.ARG]: '$',
    [COUNTRY_LIST.PER]: 'S/',
    [COUNTRY_LIST.CHL]: '$',
    [COUNTRY_LIST.ECU]: '$',
    [COUNTRY_LIST.DOM]: 'RD$',
    [COUNTRY_LIST.TUR]: '₺',
    [COUNTRY_LIST.IDN]: 'Rp', // 印尼
    [COUNTRY_LIST.PAK]: 'Rs', // 巴基斯坦
    [COUNTRY_LIST.EGY]: 'ج.م', // 埃及
    [COUNTRY_LIST.IRQ]: 'د.ع', // 伊拉克
    [COUNTRY_LIST.DZA]: 'دج ', // 阿尔及利亚
    [COUNTRY_LIST.SAU]: 'ريال', // 沙特阿拉伯王国
};

// 当前货币单位
export const currencyUnit = countryCurrencyUnit[webCountry];
